import React from 'react'
import './home.css'
import Image2 from '../../../img/shape-wawes.svg'
import Image3 from '../../../img/shape-circle.svg'
import Lottie from 'lottie-react'
import devAnimation from "../../../img/animtion/dev.json";
import {HomeData1, HomeData2,HomeData3} from './Data'


const Home = () => {
    return (
    <>
        <section className="home section" id="home">
                <div className="home__container container grid section__border">

                    <div className="home__data grid">
                        <h1 className="home__title">
                            Hi, I'm Ahmed <br/>
                            FullStack Developer <br/>
                            Based In Egypt <br/>
                        </h1>

                        <div className="home__blob grid">
                            <div className="home__perfil">
                                <Lottie animationData={devAnimation}/>
                            </div>

                            <img className="home__shape-wawes" src={Image2} alt="shape-wawes"/>
                            <img className="home__shape-circle" src={Image3} alt="shape-circle"/>
                        </div>

                        <ul className="home__social">
                        {
                            HomeData1.map((item,index)=>{
                                return(
                                    <a key={index} href={item.linkHome} rel="noreferrer" target="_blank" className="home__social-link">
                                        <i className={item.iconHome}></i>
                                    </a>
                                )
                            })
                        }
                        </ul>
                    </div>
                    {/* <!--==================== HOME INFO 1 ====================--> */}

                    <div className="home__info home__info-eng">

                        {
                            HomeData2.map((item,index)=>{
                                return(
                                    <div key={index}>
                                        <h3 className="home__info-title">
                                            {item.infoTitle}
                                        </h3>

                                        <p className="home__info-description">
                                            {item.infoDescription1} <br/>
                                            {item.infoDescription2} <br/>
                                            {item.infoDescription3}
                                        </p>
                                    </div>
                                )
                            })
                        }

                    </div>

                    {/* <!--==================== HOME INFO 2 ====================--> */}
                    <div className="home__info home__info-eng">

                        {
                            HomeData3.map((item,index)=>{
                                return(
                                    <div key={index}>
                                        <h3 className="home__info-title">
                                            {item.infoTitle}
                                        </h3>

                                        <p className="home__info-number">
                                            {item.infoNumber}
                                        </p>
                                    </div>
                                )
                            })
                        }

                    </div>

                </div>
        </section>
    </>
)
}

export default Home